import { useState, useEffect, useRef, Fragment } from 'react'
// import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import Backdrop from '../../Backdrop/Backdrop';
import Loader from '../../Loader/Loader';
// import Modal from '../../Modal/Modal';
// import UploadedFileUseContent from '../../UploadedFileUseContent/UploadedFileUseContent';
// import VoiceGenerator2Socket from '../VoiceGenerator2Socket';
// import VoiceGenerator2NoEnOutput from './VoiceGenerator2NoEnOutput';

import { useStore } from '../../../hook-store/store';
// import { 
//   generateTextAudio, 
//   getTextToSpeechModels,
//   getTextToSpeechApi,
// } from '../../../utils/voice-generator2-utils/voice-generator2-utils'

// import { TEXTAUDIOTOOLSNODE_URL } from '../../../App';

import { marks } from '../../../utils/marks';
import '../VoiceGenerator2.css';

// const modelList = [
//   {language: 'en', repoId: 'csukuangfj/vits-piper-en_US-glados|1 speaker'},
//   {language: 'tha', repoId: 'csukuangfj/vits-mms-tha'},
//   {language: 'nan', repoId: 'csukuangfj/vits-mms-nan'},
// ];
  // Thai "csukuangfj/vits-mms-tha", ฉันรักคุณ
  // Min-nan (闽南话) "csukuangfj/vits-mms-nan",  ài piaǸ chiah ē iaN̂
  

function VoiceGeneratorModelSelect(props) {

  const {
    ttsGenModels,
    speakerId,
    setSpeakerId,
    genSpeed,
    setGenSpeed,
    ttsGenRepoId,
    setTtsGenRepoId,
    ttsGenLng,
    setTtsGenLng,
    isModelLoading,
    textInput,
    ttsGenMaxText,
    isLoading,
   } = props;

  const [t] = useTranslation("translation");

  const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    textToSpeechApiExist,
  } = store.mlVoiceStore;
  const { paramFileData } = store.uiStore;


  const changeSpeakerIdHandler = (event) => {
    // const speakerIdInput = document.getElementById('tts-speakerId');
    // speakerIdInput.value = event.target.value;

    console.log(event.target.value, numberOfSpeakerId)
    if (Number(event.target.value) >= 0 && Number(event.target.value) < numberOfSpeakerId) {
      setSpeakerId(event.target.value);
    }

    if (numberOfSpeakerId === 1) {
      setSpeakerId('0');
    }
  }

  const changeSpeedHandler = (event) => {
    // const speedInput = document.getElementById('tts-speed');
    // const speedValue = document.getElementById('tts-speedValue');

    // speedInput.value = event.target.value;
    // speedValue.innerHTML = event.target.value;
    // setSpeed(event.target.value);

    setGenSpeed(Number(event.target.value));
  }

  const selectRepoIdHandler = (event, displayName) => {
    setTtsGenRepoId(event.target.value);

    if (getSpeakerNumFromRepoId(event.target.value) > 1) {
      setSpeakerId('');
    } else {
      setSpeakerId('0');
    }
  };

  const selectTtsGenLngHandler = (event) => {
    setTtsGenLng(event.target.value);
    setTtsGenRepoId('');
    setSpeakerId('0');
  }
  
  const getSpeakerNumFromRepoId = (repoId) => {
    const spNum = Number(repoId.split('|')[1]);

    if (spNum > 1) {
      return spNum;
    } else {
      return 1;
    }
    // return Number(repoId.split('|')[1]);
  }

  const createModelDisplayName = (ttsGenModels, ttsGenLng, ttsGenRepoId) => {
    let modelDisplayName = '';

    if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
      const selectedModelData = ttsGenModels.find(model => {
        return model.code === ttsGenLng;
      })
  
      if (selectedModelData) {
      
        if (ttsGenRepoId) {
          const repoIndex = selectedModelData.models.indexOf(ttsGenRepoId);
          const modelDesc = ttsGenRepoId.split('/')[1].split('|')[0];

          modelDisplayName = `${selectedModelData.name} - ${repoIndex + 1} (${modelDesc})`;
        }
      }
    }

    return modelDisplayName;

  };




  // const displayList = [];

  let selectedLngModels = [];
  let numberOfSpeakerId = 1;

  if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
    const selectedModelData = ttsGenModels.find(model => {
      return model.code === ttsGenLng;
    })

    if (selectedModelData) {
      selectedLngModels = [''].concat(selectedModelData.models);
    }

  }


  if (ttsGenRepoId && getSpeakerNumFromRepoId(ttsGenRepoId) > 1) {
    numberOfSpeakerId = getSpeakerNumFromRepoId(ttsGenRepoId);
  }

  let voiceGeneratorModelSelectBody;

  voiceGeneratorModelSelectBody = (
    <div>
        <div className='voiceGenerator2Section'>
          <div>
            {t('voiceGenerator02', 'Language')}
          </div>
          <select className='voiceGenerator2Select'
              onChange={selectTtsGenLngHandler} 
              // defaultValue={defaultLanguage}
            >
              {ttsGenModels.map((model) => {
                return (
                  <option key={model.code} value={model.code}>
                    {model.name}
                  </option>
                )
              })}
            </select>
            
            {/* <div>
              tts-gen-lng: {ttsGenLng}
            </div> */}
        </div>
        

        <div className='voiceGenerator2Section'>
          <div>
            {t('voiceGenerator03', 'Model')}
          </div>
          <select className='voiceGenerator2Select'
              onChange={selectRepoIdHandler} 
              // defaultValue={defaultLanguage}
            >
              {selectedLngModels.map((model, index) => {
      
                let dispSpeakerNum;
                let dispModelName;

                if (Number(model.split('|')[1]) > 1) {
                  dispSpeakerNum = <span>(speaker {model.split('|')[1]})</span>;
                }

                const ttsModelData = ttsGenModels.find(model => {
                  return model.code === ttsGenLng;
                });
                if (ttsModelData && index > 0) {
                  dispModelName = createModelDisplayName(
                    ttsGenModels,
                    ttsGenLng,
                    model,
                  )
                  // dispModelName = `${ttsModelData.name} - ${index}`;
                }

                return (
                  <option key={model} value={model}>
                    {dispModelName} {dispSpeakerNum}
                  </option>
                )
              })}
            </select>
            {/* <div>model-disp-name: {modelDisplayName}</div> */}
            {/* <div>
              selected-model: {ttsGenRepoId}
            </div> */}
        </div>

        
        {isModelLoading && (
          <div className='voiceGenerator2Section'>
            model loading... 
            <br/>
            <Loader />
          </div>
        )}


                {numberOfSpeakerId > 1 && (
          <div className='voiceGenerator2Section'>
            <label htmlFor="speakerId">
              {t('voiceGenerator09', 'Speaker')} ID 
            </label>
            <div className='voiceGenerator2SettingRow'>
              <div>
                <input 
                  className='voiceGenerator2SpeakerInput'
                  style={{padding: "0.25rem"}}
                  type="text" name="speakerId" 
                  // value={speakerId}
                  // value="0" 
                  placeholder={`0 - ${numberOfSpeakerId - 1}`}
                  onChange={changeSpeakerIdHandler}
                  // defaultValue={speakerIdInputValue}
                  defaultValue={''}
                />
                <span>
                  {' '}{speakerId}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className='voiceGenerator2Section'>
            <label htmlFor="speed">
              {t('voiceGenerator04', 'Speed')}
            </label>
            <div className='voiceGenerator2SettingSpeed'>
              <input className='voiceGenerator2SettingSpeedInput'
                type="range" name="speed" 
                min="0.4" max="3.5" step="0.1" 
                // value={speed ? speed : speedInputValue} 
                value={genSpeed ? genSpeed : 1} 
                onChange={changeSpeedHandler}
                // defaultValue={speakerIdInputValue}
                defaultValue={genSpeed}
              />
              <span>{genSpeed}</span>
              {/* {speed && (
                <span>{speed}</span>
              )}
              {!speed && (
                <span>{speedInputValue}</span>
              )} */}
          </div>
        </div>
    </div>
  );


  return (
    <Fragment>
      <div>
        {voiceGeneratorModelSelectBody}
      </div>
    </Fragment>
  )
}

export default VoiceGeneratorModelSelect;
